import webClient from "../config/api.config";
import { LicenceBillingConfigUpdateRequest } from "../types/licenceBillingConfig.definition";

export function getLicenceBillingConfig() {
  return webClient.request({ method: "get", url: "/licence-billing-config" });
}

export function updateLicenceBillingConfig(
  data: LicenceBillingConfigUpdateRequest
) {
  return webClient.request({
    method: "put",
    url: "/licence-billing-config",
    data,
  });
}
